/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesactionhold2Inputs */

const en_opportunitiesactionhold2 = /** @type {(inputs: Opportunitiesactionhold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Served - hold`)
};

const de_opportunitiesactionhold2 = /** @type {(inputs: Opportunitiesactionhold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versorgt - halten`)
};

/**
* | output |
* | --- |
* | "Served - hold" |
*
* @param {Opportunitiesactionhold2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesactionhold2 = /** @type {((inputs?: Opportunitiesactionhold2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesactionhold2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesactionhold2(inputs)
	return de_opportunitiesactionhold2(inputs)
});
export { opportunitiesactionhold2 as "opportunitiesActionHold" }